import { tv } from 'tailwind-variants'

import { body1 } from '@nxt-insurance/ui-kit/core/typography'

export const headerStyles = tv({
  slots: {
    headerContainer: 'fixed left-0 top-0 z-30 w-full',
    languageSwitcherContainer: 'mr-0 xl:mr-44',
    previewHeaderContainer: 'flex w-full flex-row items-center justify-center bg-brand-lime',
    previewHeader: 'flex w-full max-w-screen-2xl flex-row items-center justify-between',
    previewExitLink: body1({ className: 'inline-flex items-center' }),
    wordMark: 'flex h-full w-full',
    logo: 'flex h-full w-full',
    navbarContainer:
      'absolute z-10 flex flex-1 flex-col items-center justify-start transition-all duration-300 ease-linear max-lg:left-0 max-lg:top-0 max-lg:h-[100vh] max-lg:w-[102vw] max-lg:bg-ui-light lg:relative lg:flex-row lg:justify-end',
    navbar:
      'order-0 flex w-full flex-row items-center justify-between border-b border-ui-grey-ultra-light px-6 py-8 lg:order-1 lg:w-auto lg:border-none lg:p-0',
    navbarButton: 'block lg:hidden',
  },
  variants: {
    isMainMenuVisible: {
      true: {
        navbarContainer: 'max-lg:-translate-x-[3vw]',
      },
      false: {
        navbarContainer: 'max-lg:translate-x-[1024px]',
      },
    },
    hasCampaign: {
      true: {
        navbarContainer: 'max-lg:top-11',
      },
    },
  },
})
